import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LogoutControl from '../session/LogoutControl';
import LanguageDropdown from './LanguageDropdown';
import { useSession } from '../../contexts/SessionContext';
import logo from '../../assets/logo.png';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { sessionState } = useSession();

  return (
    <Navbar variant="dark" expand="lg" className="justify-content-center border-bottom">
      <Container fluid>
        <Link className="navbar-brand" to={'/'}>
          <img src={logo} alt="Logo" height={40} />
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className='d-flex justify-content-center' id="basic-navbar-nav">
          <Nav>
            {sessionState.account && sessionState.account.userName ? (
              <NavDropdown className="m-auto fs-5 fw-semibold position-relative top-0 start-100 translate-middle-x z-3" title="Administration" id="basic-nav-dropdown">
                <NavDropdown.Item as={Link} to="/tools">{t('tools.title')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/devices">{t('devices.title')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services">{t('services.title.overview')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/git-admin">{t('gitAdmin.title')}</NavDropdown.Item>
              </NavDropdown>
            ) : (<></>)}
          </Nav>
        </Navbar.Collapse>

        <Nav>
          <LanguageDropdown />
          {sessionState.account && sessionState.account.userName ? (
            <>
              <Nav.Link className="text-center fs-5 fw-semibold text-capitalize" as={Link} to="/profile">
                {sessionState.account && sessionState.account.userName}
              </Nav.Link>
              <LogoutControl />
            </>
          ) : (
            <Nav.Link className="text-center fs-5 fw-semibold" as={Link} to="/login">{t('login.login')}</Nav.Link>
          )}
        </Nav>
      </Container>
    </Navbar>
  );
};

export default Header;
